import { FileItem } from '../api/ApiTypes'
import { getCustomerApiClient } from '../api/CustomerApiClient'

export const FILE_SIGNATURE_EXPIRATION = 1000 * 60 * 15

const getDownloadUrl = async (file: FileItem): Promise<string> => {
  if (file.access_control === 'public-read') {
    return file.public_url
  }

  // Get the file from the API which includes the presigned public url
  const { data } = await getCustomerApiClient().getFileById({
    id: file._id
  })

  return data?.file?.public_url
}

type FileAccessParams = {
  file: FileItem
  isAdminSession?: boolean
}

export const getIsFileExtensionAllowed = (
  allowedExtensions: Record<string, string[]>
) => {
  const allowed = new Set(Object.values(allowedExtensions).flat())

  return (filename: string) => {
    const extension = filename.split('.').pop()

    return allowed.has(extension)
  }
}

export const openFile = async ({ file, isAdminSession }: FileAccessParams) => {
  const downloadUrl = await getDownloadUrl(file)

  const link = document.createElement('a')

  link.href = downloadUrl
  link.target = '_blank' // just in case it wouldn't be downloaded, but it should
  link.rel = 'noopener noreferrer'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  // Track the user has downloaded the file but only if it's not an admin
  // logged in as a customer
  if (!isAdminSession) {
    getCustomerApiClient().trackFileDownloaded({ id: file._id })
  }
}

export const getBinaryContent = async ({
  file,
  isAdminSession
}: FileAccessParams) => {
  const downloadUrl = await getDownloadUrl(file)

  const response = await fetch(downloadUrl)

  // Track the user has downloaded the file but only if it's not an admin
  // logged in as a customer
  if (!isAdminSession) {
    getCustomerApiClient().trackFileDownloaded({ id: file._id })
  }

  return response.blob()
}
